import React from "react";
import Dialog from "../base/ui/components/web/Dialog";
import { useDispatch } from "react-redux";
import { removeImage } from "./actions";
export function RemoveImageDialog({ image }) {
    const dispatch = useDispatch();
    return (React.createElement(Dialog, { title: "\u00BFQuieres eliminar esta imagen?", onSubmit: () => {
            dispatch(removeImage(image.id, true));
        } }, "Al eliminar la imagen esta sera eliminada de toda la pizarra"));
}
